import React from "react";
import { Redirect } from "react-router-dom";
import { UseFormReturn } from "react-hook-form";

import {
	LoginFormState
} from "./models";

import {
	t,
	Trans,
} from "@lingui/macro";

import "./style.css";

import {
	Box,
	Button,
	Grid,
	Link,
	Typography
} from "@mui/material";

import { withUseFormHook } from "@sinossi/mates-react-library";
import * as Yup from "yup";
import AuthenticationService from "services/authentication-service";

import {
	ZPlayNetworkService,
	ZPlayLoader
} from "commons";
import { ZPlayFormField } from "commons/fields";

const LoginSchema = Yup.object().shape({

	email: Yup.string().email(t({
		id: "lf-email-valid-msg",
		message: "Inserire un indirizzo e-mail valido"
	})).required(t({
		id: "lf-email-required-msg",
		message: "L'indirizzo e-mail è obbligatorio"
	})),
	password: Yup.string().required(t({
		id: "lf-password-required-msg",
		message: "La password è obbligatoria"
	}))
});

class LoginForm extends React.Component<UseFormReturn, LoginFormState>
{

	constructor(props: any) {
		super(props);

		this.state = {
			loaded: true,
			successLogin: false,
			redirectReason: null,
			errorLogin: false,
		};
	}

	componentDidMount() {
		let params = (new URL(window.location.href)).searchParams;
		let redirectReason: string | null = params.get("redirectReason") || "";

		if (redirectReason !== "") {
			this.setState(() => ({ redirectReason: redirectReason }));
		}
	}

	submitForm = (values: any) => {

		this.setState(() => ({ loaded: false }));

		let loginRequest = {
			email: values.email,
			password: values.password
		};

		AuthenticationService.login(loginRequest, this.loginSuccessCallback, this.loginErrorCallback);
	};

	getCurrentUserCallBack = (data: any) => {

		localStorage.setItem("current_user", JSON.stringify(data));
		window.dispatchEvent(new Event("user-storage"));

		this.setState(() => ({ successLogin: true }));
	};

	loginSuccessCallback = (data: any) => {

		localStorage.setItem(ZPlayNetworkService.TOKEN_KEY || "token", data.IdToken);
		localStorage.setItem(ZPlayNetworkService.REFRESH_TOKEN_KEY || "refresh_token", data.RefreshToken);

		AuthenticationService.getCurrentUser(this.getCurrentUserCallBack, this.loginErrorCallback);
	};

	loginErrorCallback = (err: any) => {
		this.setState(() => ({ loaded: true, errorLogin: true }));
		console.log(err);
	};

	render() {

		let allowRegistration = process.env.REACT_APP_ALLOW_REGISTRATION === "true"
		let backofficeMode = process.env.REACT_APP_BACKOFFICE_MODE === "true"

		return (<>
			{this.state.successLogin && <Redirect to={backofficeMode ? "/backoffice/choose-action" : "/"} />}
			<Box className={"login-form-container"}>
				<form onSubmit={this.props.handleSubmit(this.submitForm)}>
					<Grid container rowSpacing={0.5}>
						<Grid item xs={12}>
							<Typography variant="h1" component="div" color={"white"} gutterBottom
								sx={{
									textTransform: "uppercase",
									fontWeight: "bold"
								}}>
								<Trans id="lf-login-title">Login</Trans>
							</Typography>
						</Grid>
						{this.state.redirectReason && <Grid item xs={12}>
							<Typography variant="h3" component="div" color={"white"} gutterBottom
								sx={{
									fontWeight: "bold",
									color: this.state.redirectReason !== "successful_reg" ? "red" : "green"
								}}>
								{(this.state.redirectReason === "expired") && <Trans id="lf-expired-session">
									La sessione è scaduta. Effettua nuovamente l'accesso
								</Trans>}
								{(this.state.redirectReason === "auth_required") && <Trans id="lf-auth_required">
									Per accedere alla pagina è necessario essere autenticati.
								</Trans>}
								{(this.state.redirectReason === "no_privileges") && <Trans id="lf-no-privileges">
									Non hai i privilegi necessari per accedere alla pagina.
								</Trans>}
								{(this.state.redirectReason === "successful_reg") && <Trans id="lf-successful-reg">
									La registrazione ha avuto successo. Effettua il login con le tue credenziali
								</Trans>}
							</Typography>
						</Grid>}
						{this.state.errorLogin && <Grid item xs={12}>
							<Typography variant="h3" component="div" color={"white"} gutterBottom
								sx={{
									fontWeight: "bold",
									color: "red"
								}}>
								<Trans id="lf-max-active-session-2">
									Si è verificato un errore durante il login, verifica le credenziali o il numero di dispositivi connessi
								</Trans>
							</Typography>
						</Grid>}
						<Grid item xs={12}>
							<ZPlayFormField
								name="email"
								label={t({
									id: "lf-email",
									message: "Email",
								})}
								formState={this.props.formState}
								control={this.props.control}
								trigger={this.props.trigger}
							/>
						</Grid>
						<Grid item xs={12}>
							<ZPlayFormField
								name="password"
								label={t({
									id: "lf-password",
									message: "Password",
								})}
								type="password"
								formState={this.props.formState}
								control={this.props.control}
								trigger={this.props.trigger}
							/>
						</Grid>
						<Grid item xs={12}>
							<Button variant="contained"
								color={"secondary"}
								size={"large"}
								fullWidth
								disabled={this.props.formState.isSubmitting}
								type="submit"
								sx={{
									mt: "80px",
									textTransform: "none",
								}}>
								<Trans id="lf-login-button">Login</Trans>
							</Button>
						</Grid>
						{allowRegistration && <Grid item xs={12}>
							<br />
							<Typography variant="body2" component="div" color={"white"} gutterBottom
								sx={{ textAlign: "center" }}>
								<Trans id="lf-text">Non possiedi ancora un account?</Trans>
								<br />
								<Link className={"login-link"} href="/registration" variant="body2" color="secondary">
									<Trans id="lf-registration-link">Registrati</Trans>
								</Link>
							</Typography>
						</Grid>}
					</Grid>
				</form>
			</Box>
			{!this.state.loaded && <ZPlayLoader />}
		</>);
	}
}

export default withUseFormHook<{}>(LoginForm, LoginSchema, {});
